import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77329fff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg"
}
const _hoisted_2 = {
  key: 0,
  class: "toast"
}
const _hoisted_3 = { class: "toast_container_wrap_title" }
const _hoisted_4 = {
  key: 0,
  class: "toast_container_comfirm"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { computed, ref } from 'vue';
  import BaseIcon from '../Base/BaseIcon/src/BaseIcon.vue';
  import { useResize } from '@/hooks/useResize';
  import { ToastTypesList, ToastOption, ToastType, ToastObjType, ToastComfirmType } from './typings';
  // 全局弹窗

  
export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

  const { px2rem } = useResize();
  let timer: Nullable<TimeoutHandle> = null;
  const visible = ref(false);
  const title = ref('');
  const types: ToastTypesList = ['loading', 'warning', 'success', 'error', 'question'];
  const icon = ref('success');
  const duration = ref(2000);
  const paddingBottom = computed(() => px2rem(isConfirm.value ? 0 : 60));

  const Toast: ToastType = (opt) => {
    if (typeof opt == 'string') {
      return ToastObj({
        title: opt,
        type: 'success',
      });
    }
    if (typeof opt == 'object') {
      return ToastObj(opt);
    }
  };

  const isConfirm = ref(false);

  const ToastObj: ToastObjType = (option: ToastOption) => {
    title.value = option.title!;
    isConfirm.value = false;
    duration.value = option.type == 'loading' ? 0 : option.duration != undefined ? option.duration : 2000;
    if (types.includes(option.type!)) {
      icon.value = option.type!;
    } else {
      icon.value = 'success';
    }
    visible.value = true;
    return new Promise<void>((resolve) => {
      if (duration.value != 0) {
        createTimeout().then(() => resolve());
      } else {
        resolve();
      }
    });
  };

  let _heandleOk: Nullable<Fn<void>> = null;
  let _heandleCancel: Nullable<Fn<void>> = null;
  const ToastComfirm: ToastComfirmType = (opt: ToastOption) => {
    _heandleOk = opt.ok!;
    _heandleCancel = opt.cancel!;
    duration.value = 0;
    icon.value = 'question';
    title.value = opt.title!;
    isConfirm.value = true;
    visible.value = true;
  };

  function heandleOk() {
    close();
    _heandleOk && _heandleOk();
    _heandleOk = null;
    _heandleCancel = null;
  }

  function heandleCancel() {
    close();
    _heandleCancel && _heandleCancel();
    _heandleOk = null;
    _heandleCancel = null;
  }

  function createTimeout() {
    return new Promise<void>((resolve) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        clearTimeout(timer as TimeoutHandle);
        close();
        resolve();
      }, duration.value);
    });
  }

  function close() {
    visible.value = false;
    isConfirm.value = false;
  }

  const width = computed(() => px2rem(450));

  const type = computed(() => 'toast-' + icon.value);

  expose({
    Toast,
    ToastComfirm,
    ToastObj,
    close,
    types,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "bg" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "show" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "toast_container",
                style: _normalizeStyle({ width: _unref(width) + 'rem' })
              }, [
                _createElementVNode("div", {
                  class: "toast_container_wrap",
                  style: _normalizeStyle({
            paddingBottom: _unref(paddingBottom) + 'rem',
          })
                }, [
                  _createVNode(BaseIcon, {
                    class: "toast_container_wrap_icon",
                    name: _unref(type)
                  }, null, 8, ["name"]),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(title.value), 1)
                ], 4),
                (isConfirm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("button", { onClick: heandleOk }, "确定"),
                      _hoisted_5,
                      _createElementVNode("button", { onClick: heandleCancel }, "取消")
                    ]))
                  : _createCommentVNode("", true)
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})